import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface Team {
  name: string;
  owner_email: string;
  role: string;
  teamId: string;
  tokens: number;
}

interface User {
  uid: string;
  email: string | null;
  displayName: string | null;
  teams?: Team[];
}

interface AuthState {
  user: User | null;
  setUser: (user: User | null) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      clearUser: () => set({ user: null }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage), 
      partialize: (state) => ({ user: state.user }),
    }
  )
);
